/*
 * @Author: 御坂网络服务 wangweigang@gooagoo.com
 * @Date: 2022-05-05 14:40:07
 * @LastEditors: 御坂网络服务 wangweigang@gooagoo.com
 * @LastEditTime: 2022-05-05 15:27:13
 * @FilePath: \parkinglot-web\src\util\util.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  findIndex(ary, fn) {
    if (ary.findIndex) {
      return ary.findIndex(fn)
    }
    /* istanbul ignore next */
    let index = -1
    /* istanbul ignore next */
    ary.some(function (item, i, ary) {
      const ret = fn.call(this, item, i, ary)
      if (ret) {
        index = i
        return ret
      }
    })
    /* istanbul ignore next */
    return index
  },
  // 设置sessionStorage
  setSessionStorage(name, value) {
    const dataType = typeof name
    if (['object', 'string', 'boolean', 'number'].indexOf(dataType) > -1) {
      window.sessionStorage.setItem(name, JSON.stringify(value))
    } else {
      alert('该类型不能用于本地存储')
    }
  },
  // 取出sessionStorage
  getSessionStorage(name) {
    const value = window.sessionStorage.getItem(name)
    if (value) {
      return JSON.parse(value)
    } else {
      return ''
    }
  },
  // 移除sessionStorage
  deleteSessionStorage(name) {
    const value = window.sessionStorage.getItem(name)
    if (value) {
      window.sessionStorage.removeItem(name)
    }
  },
  // 判断是否为Android设备
  isAndroid() {
    /* eslint-disable */
    let u = navigator.userAgent
    let app = navigator.appVersion
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 //android终端或者uc浏览器
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端 
    return isAndroid
    /* eslint-disable */
  }
}


// WEBPACK FOOTER //
// ./src/util/util.js